
import React, { useState } from 'react';
import { FaTimes } from 'react-icons/fa';
import { addNearestInfra } from '../../../../FeatureRedux/ProjectionReducer/NearestInfrastructure/addNearestInfrastructure';
import { useDispatch } from 'react-redux';
import { GetTransportDetail } from '../../../../FeatureRedux/ProjectionReducer/TransportProjectionReducer/getTransport_Projection_reducre';

const AddInfrastructureModal = ({ isOpen, onClose, onSubmit, infrastructureToEdit , projectiondataID }) => {
  const isEditMode = !!infrastructureToEdit;
  const [formData, setFormData] = useState(
    infrastructureToEdit || {
      name: '',
      type: '',
      distance: '',
       
    }
  );
  const dispatch = useDispatch()

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    var nearest_infrastructure = [formData];
    console.log(nearest_infrastructure)
    await dispatch(addNearestInfra({nearest_infrastructure , projectiondataID}))
    // setTimeout(() => {
     const projectid = projectiondataID.projectid
    //  console.log('thushsby ush',projectiondataID)
    dispatch(GetTransportDetail(projectiondataID))
      
    // }, 1000);
    onClose();
  };

  if (!isOpen) return null;
  
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-gray-800 rounded-lg p-6 w-full max-w-md relative">
        <button
          onClick={onClose}
          className="absolute top-4 right-4 text-gray-400 hover:text-white"
        >
          <FaTimes size={20} />
        </button>
        
        <h3 className="text-lg font-semibold mb-4">
          {isEditMode ? 'Edit Infrastructure' : 'Add New Infrastructure'}
        </h3>
        
        <form onSubmit={handleSubmit}>
          <div className="mb-4">
            <label className="block text-gray-300 mb-2">Name</label>
            <input
              type="text"
              name="name"
              value={formData.name}
              onChange={handleInputChange}
              className="w-full px-3 py-2 bg-gray-700 border border-gray-600 rounded text-white"
              required
            />
          </div>
          
          <div className="mb-4">
            <label className="block text-gray-300 mb-2">Type</label>
            <input
              type="text"
              name="type"
              value={formData.type}
              onChange={handleInputChange}
              className="w-full px-3 py-2 bg-gray-700 border border-gray-600 rounded text-white"
              required
            />
          </div>
          
          <div className="mb-4">
            <label className="block text-gray-300 mb-2">Distance</label>
            <input
              type="text"
              name="distance"
              value={formData.distance}
              onChange={handleInputChange}
              className="w-full px-3 py-2 bg-gray-700 border border-gray-600 rounded text-white"
              required
            />
          </div>
          
          {/* <div className="mb-6">
            <label className="block text-gray-300 mb-2">Direction</label>
            <input
              type="text"
              name="direction"
              value={formData.direction}
              onChange={handleInputChange}
              className="w-full px-3 py-2 bg-gray-700 border border-gray-600 rounded text-white"
              required
            />
          </div> */}
          
          <div className="flex justify-end">
            <button
              type="button"
              onClick={onClose}
              className="mr-3 px-4 py-2 bg-gray-600 hover:bg-gray-500 rounded"
            >
              Cancel
            </button>
            <button
              type="submit"
              className="px-4 py-2 bg-blue-600 hover:bg-blue-500 rounded"
            >
              {isEditMode ? 'Update' : 'Submit'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddInfrastructureModal;
// import React, { useState } from 'react';
// import { FaTimes } from 'react-icons/fa';
// // import addNearestInfraSlice from '../slices/infrastructureSlice';
// import { addNearestInfraSlice } from '../../../../FeatureRedux/ProjectionReducer/NearestInfrastructure/addNearestInfrastructure';
// import { useDispatch } from 'react-redux';

// const AddInfrastructureModal = ({ isOpen, onClose, onSubmit, infrastructureToEdit }) => {
//   const isEditMode = !!infrastructureToEdit;
//   const [formData, setFormData] = useState(
//     infrastructureToEdit || {
//       name: '',
//       type: '',
//       distance: '',
//       direction: ''
//     }
//   );
//   const dispatch = useDispatch()

//   const handleInputChange = (e) => {
//     const { name, value } = e.target;
//     setFormData(prev => ({
//       ...prev,
//       [name]: value
//     }));
//   };

//   const handleSubmit = (e) => {
//     e.preventDefault();
//     var nearest_infrastructure = [];
//     nearest_infrastructure = [formData];
//     console.log(nearest_infrastructure)
//     dispatch(addNearestInfraSlice({nearest_infrastructure}))
//     return;
//     // onSubmit(formData);
//     // onClose();
//   };

//   if (!isOpen) return null;
  

//   return (
//     <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
//        <div className="bg-gray-800 rounded-lg p-6 w-full max-w-md relative">
//         <button
//           onClick={onClose}
//           className="absolute top-4 right-4 text-gray-400 hover:text-white"
//         >
//           <FaTimes size={20} />
//         </button>
        
//         <h3 className="text-lg font-semibold mb-4">
//           {isEditMode ? 'Edit Infrastructure' : 'Add New Infrastructure'}
//         </h3>
        
//         <form onSubmit={handleSubmit}>
//           <div className="mb-4">
//             <label className="block text-gray-300 mb-2">Name</label>
//             <input
//               type="text"
//               name="name"
//               value={formData.name}
//               onChange={handleInputChange}
//               className="w-full px-3 py-2 bg-gray-700 border border-gray-600 rounded text-white"
//               required
//             />
//           </div>
          
//           <div className="mb-4">
//             <label className="block text-gray-300 mb-2">Type</label>
//             <input
//               type="text"
//               name="type"
//               value={formData.type}
//               onChange={handleInputChange}
//               className="w-full px-3 py-2 bg-gray-700 border border-gray-600 rounded text-white"
//               required
//             />
//           </div>
          
//           <div className="mb-4">
//             <label className="block text-gray-300 mb-2">Distance</label>
//             <input
//               type="text"
//               name="distance"
//               value={formData.distance}
//               onChange={handleInputChange}
//               className="w-full px-3 py-2 bg-gray-700 border border-gray-600 rounded text-white"
//               required
//             />
//           </div>
          
//           <div className="mb-6">
//             <label className="block text-gray-300 mb-2">Direction</label>
//             <input
//               type="text"
//               name="direction"
//               value={formData.direction}
//               onChange={handleInputChange}
//               className="w-full px-3 py-2 bg-gray-700 border border-gray-600 rounded text-white"
//               required
//             />
//           </div>
          
//           <div className="flex justify-end">
//             <button
//               type="button"
//               onClick={onClose}
//               className="mr-3 px-4 py-2 bg-gray-600 hover:bg-gray-500 rounded"
//             >
//               Cancel
//             </button>
//             <button
//               type="submit"
//               className="px-4 py-2 bg-blue-600 hover:bg-blue-500 rounded"
//             >
//               {isEditMode ? 'Update' : 'Submit'}
//             </button>
//           </div>
//         </form>
//       </div>
//     </div>
//   );
// };

// export default AddInfrastructureModal;